export interface ICoordinator {
    contactId: number,
    fullName: string,
    coordinatorType: number,
    totalCaseCount: number,
    activeCaseCount: number
}